import PropTypes from 'prop-types';
import withBreakpoint from 'core/hocs/withBreakpoint';

import Snippet from '../snippet';
import styles from './index.styl';

function SmartSlides(block) {
  const {
    attributes,
    id,
    type,
  } = block;
  const {
    html_left: htmlLeft,
    html_right: htmlRight,
  } = attributes;

  const propsForLeft = {
    id,
    type,
    attributes: {
      html: htmlLeft,
    },
  };

  const propsForRight = {
    id: id + 1,
    type,
    attributes: {
      html: htmlRight,
    },
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.leftSnippet}>
        <Snippet {...propsForLeft} />
      </div>
      <div className={styles.divider} />
      <div className={styles.rightSnippet}>
        <Snippet {...propsForRight} />
      </div>
    </div>
  );
}

SmartSlides.propTypes = {
  id: PropTypes.string,
  type: PropTypes.string,
  attributes: PropTypes.shape({
    html_left: PropTypes.string,
    html_right: PropTypes.string,
  }),
};

const SmartSlidesWithHOCs = withBreakpoint(SmartSlides);
SmartSlidesWithHOCs.displayName = 'SmartSlides';

export { SmartSlides };
export default SmartSlidesWithHOCs;
